import { Navigate, Outlet, useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import config from "../config";

const ProtectedRoute = () => {
    const { lang } = useParams(); // Récupère la langue de l'URL
    const [isAdmin, setIsAdmin] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const checkAuth = async () => {
            try {
                const response = await fetch(`${config.API_BASE_URL}/api/auth/verify`, {
                    method: "GET",
                    credentials: "include",
                });
    
                if (!response.ok) {
                    throw new Error("Non autorisé");
                }

                const data = await response.json();
                setIsAdmin(data.isAuthenticated && data.role === "admin");

            } catch (error) {
                console.error("Erreur d'authentification", error);
                setIsAdmin(false);
            } finally {
                setLoading(false);
            }
        };

        checkAuth();
    }, []);

    if (loading) {
        return <div>Chargement...</div>;
    }

    // Si l'utilisateur n'est pas un admin, on redirige vers la page Unauthorized
    return isAdmin ? <Outlet /> : <Navigate to={`/${lang}/unauthorized`} />;
};

export default ProtectedRoute;
